import { h, Component } from 'preact';
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import constants, { priceColumns } from "../constants";
import MenuObject from "../canvas/menu-object";
import util, { roundOneDecimalScaled } from "../util";
import Interactable from "../canvas/interactable";
import Renderer from "../canvas/renderer";
import FontFamilyWidget from './FontFamilyWidget';
import TextSizeWidget from "./TextSizeWidget";
import TextStyleWidget from './TextStyleWidget';

export default @connect(reduce, actions)
class MenuObjectStyles extends Component {
  constructor(props) {
    super()

    this.currentColor = () => {
      if (this.props.menuObjectStyles['icon-entry'] && this.props.menuObjectStyles['icon-entry']['color']) {
        return this.props.menuObjectStyles['icon-entry']['color'];
      }
      return '#fff';
    }
    this.$element = props.$element;

    this.onIconPositionChange = (ev) => {
      const position = ev.target.id;
      MenuObject.updateIconPosition(this.props.$element, position);
    }
  }

  updateColor(value) {
    this.props.onStyleChange('color', value);
  }

  updateIconLayout(key) {
    MenuObject.updateIconLayout(this.props.$element, key);
    this.props.setIconLayout(key);
  }

  updateIconsInDescription(iconsInDescription) {
    MenuObject.updateIconsInDescription(this.props.$element, iconsInDescription);
    this.props.setIconsInDescription(iconsInDescription);
  }

  adjustPercent(originalSize, scale, percent) {
    const expectedValue = roundOneDecimalScaled(originalSize);
    const actualValue = roundOneDecimalScaled(util.convertInlineSize(percent) * scale);

    if (expectedValue !== actualValue) {
      if (expectedValue > actualValue) {
        return this.adjustPercent(originalSize, scale, percent + 0.01);
      } else {
        return this.adjustPercent(originalSize, scale, percent - 0.01);
      }
    }

    return percent;
  }

  changeSize(size) {
    size = size.target ? size.target.value : size;

    if (size > 400) {
      size = 400;
    }

    const originalSize = size;
    const scale = Interactable.of(this.$element).getScale();

    size /= scale;

    let percent = 0;
    const dims = Renderer.getDimensions();
    if (dims.unit === 'in') {
      const pixels = util.getPointsInPixels(size, dims);
      percent = util.pixelToPercent(pixels, dims.fontSize);
    } else {
      percent = size * constants.PIXEL_FONT_SIZE_ADJUSTMENT;
    }

    percent = this.adjustPercent(originalSize, scale, percent);

    this.props.onAllStyleChange('font-size', `${percent}%`, this.props.priceNum !== null ? this.props.priceNum : null);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.$element = nextProps.$element;
  }

  changeFontFamily(font) {
    this.props.onStyleChange('font-family', font.font, this.props.priceNum !== null ? this.props.priceNum : null);
  }

  render(props, state) {
    const iconAlign = this.props.iconLayout || 'icon-right';
    const iconsInDescription = this.props.iconsInDescription;
    const iconLayouts = ['icon-left', 'icon-right'];
    const iconLayoutJsx = iconLayouts.map(layout => (
      <li className="option">
        <a className={iconAlign === layout ? 'act icn' : 'icn'} onClick={() => this.updateIconLayout(layout)}>
          <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg" + (layout === 'icon-left' ? '#app-align-left' : '#app-align-right')} /></svg>
        </a>
      </li>
    ));
    const allIconStyles = props.menuObjectStyles['icon'] ? props.menuObjectStyles['icon'] : props.menuObjectStyles['name'] ? props.menuObjectStyles['name'] : {};
    const fontSize = util.convertInlineSize(allIconStyles['font-size'] || 100);
    let hasLetterIcon = false;
    props.menuObjectItems.forEach(it => {
      if (it.icons && it.icons.length) {
        it.icons.forEach(ic => {
          if (ic.type === 'letter') {
            hasLetterIcon = true;
          }
        })
      }
    });

    const allIconEntryStyles = props.menuObjectStyles['icon-entry'] ? props.menuObjectStyles['icon-entry'] : {};
    const styleFont = allIconEntryStyles['font-family'];
    const font = util.getFontByFamily(styleFont);
    const fontKey = font ? font.key : '';
    const fontFamily = font ? font.label : '';

    return (
      <div className="iconStyleContainer mos">
        <div class="styles-label">
          <h5>{props.label}</h5>
          {props.applyToAllDD ? props.applyToAllDD : <div></div>}
        </div>

        <ul>
          {hasLetterIcon &&
            <li className="font-wrap">
              <FontFamilyWidget fontKey={fontKey} family={fontFamily} changeFont={this.changeFontFamily.bind(this)} />
            </li>}
          <li className="size-wrap">
            <TextSizeWidget key={`mo-size-${props.label}`} $element={props.$element} value={fontSize} onChange={this.changeSize.bind(this)} />
          </li>
          {hasLetterIcon && <li className="text-wrap">
            <TextStyleWidget $element={props.$element} menuObjectStyles={props.menuObjectStyles} type={'icon-entry'} onStyleChange={props.onStyleChange} priceNum={props.priceNum} />
          </li>}
          {props.iconPosition !== 'price' && iconLayoutJsx}
          <li className="color-wrap saf-stop">
            <a onClick={() => this.props.openColorPicker(constants.pickerTypes.moFont)}>
              <span className="color-box" style={`background: ${this.currentColor()}; float: none;`}></span>
            </a>
          </li>
        </ul>

        <div className="show-prices-switch icon-pos-radio mos">
          <div>
            <input type="radio" name="iconPosition" id="name" onClick={(ev) => this.onIconPositionChange(ev)} checked={props.iconPosition === "name"} />
            <label for="name">In-line with Name</label>
          </div>
          <div>
            <input type="radio" name="iconPosition" id="description" onClick={(ev) => this.onIconPositionChange(ev)} checked={props.iconPosition === "description"} />
            <label for="description">In-line with Item Description</label>
          </div>
          {!priceColumns.includes(props.menuObjectLayout) &&
          <div>
            <input type="radio" name="iconPosition" id="price" onClick={(ev) => this.onIconPositionChange(ev)} checked={props.iconPosition === "price"} />
            <label for="price">Icon after Item Price</label>
          </div>}

          {/*<h5>In-line with Name</h5>
          <Switch checked={iconsInDescription} onChange={this.updateIconsInDescription.bind(this)} size="small" />
          <h5>In-line with Description</h5>*/}
        </div>
      </div>
    )
  }
}
